import { useState } from "react";
import PageHeader from "@/components/PageHeader";
import DataTable from "@/components/DataTable";
import EntityDialog from "@/components/EntityDialog";
import { StatusBadge } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { DoorOpen, Plus, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";

export default function GateRegister() {
  const { can } = useAuth();
  const [open, setOpen] = useState(false);
  const [refresh, setRefresh] = useState(0);

  const exit = async (row, reload) => {
    try { await api.post(`/gate-register/${row.id}/exit`); toast.success("Exit recorded"); reload(); }
    catch { toast.error("Failed"); }
  };

  const cols = [
    { key: "gate_pass_no", label: "Gate Pass", mono: true },
    { key: "type", label: "Type", render: (r) => <span className="capitalize">{r.type}</span> },
    { key: "person_name", label: "Person / Driver" },
    { key: "vehicle_no", label: "Vehicle", mono: true },
    { key: "purpose", label: "Purpose" },
    { key: "entry_time", label: "Entry", render: (r) => r.entry_time ? new Date(r.entry_time).toLocaleTimeString() : "—" },
    { key: "exit_time", label: "Exit", render: (r) => r.exit_time ? new Date(r.exit_time).toLocaleTimeString() : "—" },
    { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} /> },
  ];

  const fields = [
    { name: "type", label: "Entry Type", type: "select", required: true,
      options: ["visitor", "employee", "material", "vehicle"].map((v) => ({ value: v, label: v })) },
    { name: "person_name", label: "Person / Driver Name", required: true },
    { name: "vehicle_no", label: "Vehicle No" },
    { name: "purpose", label: "Purpose", full: true },
  ];

  return (
    <div>
      <PageHeader title="In / Out Register" subtitle="Gate pass, security verification & time logs" icon={DoorOpen}
        breadcrumb={["Home", "Operations", "Gate"]}
        actions={can("gate.create") && (
          <Button data-testid="add-gate-btn" onClick={() => setOpen(true)} className="bg-blue-600 hover:bg-blue-700">
            <Plus className="h-4 w-4 mr-1.5" />New Entry
          </Button>
        )} />
      <DataTable endpoint="/gate-register" columns={cols} testId="gate-table" refreshKey={refresh}
        actions={(row, reload) => row.status === "in" && can("gate.update") && (
          <Button size="sm" variant="outline" data-testid={`exit-gate-${row.id}`} onClick={() => exit(row, reload)}
            className="text-slate-600">
            <LogOut className="h-4 w-4 mr-1" />Record Exit
          </Button>
        )} />
      <EntityDialog open={open} onOpenChange={setOpen} title="New Gate Entry" fields={fields}
        endpoint="/gate-register" onSaved={() => setRefresh((r) => r + 1)} />
    </div>
  );
}
